import React from "react";

const Careers = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section
        className="h-[70vh] bg-cover bg-center flex flex-col justify-center items-center text-white text-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1542744173-05336fcc7ad4?auto=format&fit=crop&w=1600&q=80')",
        }}
      >
        <div className="bg-black/50 p-8 rounded-xl max-w-3xl mx-auto">
          <h1 className="text-5xl font-bold mb-3">Build a Future Your Way</h1>
          <p className="text-lg leading-relaxed">
            BlueShield Labs — Empowering Professionals. Shaping Careers. Building Futures.
          </p>
        </div>
      </section>

      {/* Description Section */}
      <section className="max-w-6xl mx-auto py-16 px-6 text-center">
        <h2 className="text-3xl font-semibold text-blue-800 mb-8">
          Why Work With BlueShield Labs?
        </h2>

        <div className="text-gray-700 text-lg leading-relaxed space-y-6 text-justify">
          <p>
            BlueShield Labs is a forward-thinking IT employment and talent consulting agency
            connecting professionals in technology, business, and administration with
            top-tier organizations across the United States. We partner with companies
            seeking skilled and driven individuals like you — helping you find opportunities
            that align with your expertise, goals, and lifestyle.
          </p>

          <p>
            Let BlueShield Labs handle the search for your next opportunity, so you can focus
            on what you do best — innovating, creating, and advancing your career.
          </p>

          <p>
            Our mission is to deliver innovative, measurable, and value-driven recruitment
            solutions through a state-of-the-art talent acquisition model designed to maximize
            client success and empower candidate growth. With BlueShield Labs you can:
          </p>

          <ul className="list-disc list-inside text-left mx-auto max-w-3xl space-y-2">
            <li>Find projects that fully utilize your expertise and potential</li>
            <li>Add flexibility and diversity to your professional journey</li>
            <li>Work where and when you choose with opportunities that fit your lifestyle</li>
            <li>Connect directly with decision makers and hiring leaders at top employers</li>
          </ul>

          <p className="pt-4 font-semibold text-blue-800 text-center">
            BlueShield Labs — Empowering Professionals. Shaping Careers. Building Futures.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-10 mt-16">
          {[
            {
              title: "Career Guidance",
              desc: "Our Career Counselors help align your skills with meaningful opportunities.",
            },
            {
              title: "Interview Support",
              desc: "Get personalized resume reviews, interview tips, and preparation sessions.",
            },
            {
              title: "Direct Employer Access",
              desc: "Work directly with decision-makers at leading U.S. employers.",
            },
          ].map((c, i) => (
            <div
              key={i}
              className="bg-gray-50 border border-gray-200 rounded-2xl p-6 hover:shadow-lg transition-all"
            >
              <h3 className="text-xl font-semibold text-blue-800 mb-2">{c.title}</h3>
              <p className="text-gray-600">{c.desc}</p>
            </div>
          ))}
        </div>

        <a
          href="/contact"
          className="mt-12 inline-block bg-blue-700 text-white px-8 py-3 rounded-lg shadow-md hover:bg-blue-800 transition-all font-semibold"
        >
          Contact Us →
        </a>
      </section>
    </div>
  );
};

export default Careers;
